import React, { useState, useEffect, useCallback, useMemo } from "react";
import axios from "../utils/axiosInstance";
import { useToast } from "./ConfirmDialog";
import { io } from "socket.io-client";

const API = "";

const SOCKET_URL = process.env.REACT_APP_API_URL || (typeof window !== "undefined" ? window.location.origin : "http://localhost:5000");

const Styles = () => (
  <style>{`
.ir-container { max-width: 1200px; margin: 0 auto; }
.ir-header-card {
  background: linear-gradient(135deg, #003366 0%, #004080 100%);
  border-radius: 12px;
  padding: 20px 24px;
  margin-bottom: 20px;
  border-left: 5px solid #FFD700;
  box-shadow: 0 2px 8px rgba(0,51,102,0.2);
}
.ir-header-card h2 { color: #ffffff; font-size: 1.1rem; font-weight: 700; margin: 0; display: flex; align-items: center; gap: 10px; }
.ir-header-card p { color: rgba(255,255,255,0.7); font-size: 0.82rem; margin: 4px 0 0; }
.ir-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
}
.ir-tab {
  padding: 10px 20px;
  border-radius: 8px;
  border: 1px solid #d1d9e6;
  background: #ffffff;
  color: #475569;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
  display: flex;
  align-items: center;
  gap: 6px;
}
.ir-tab:hover { border-color: #003366; color: #003366; background: #f8fafc; }
.ir-tab.active { background: #003366; color: #ffffff; border-color: #003366; box-shadow: 0 2px 8px rgba(0,51,102,0.25); }
.ir-tab i { font-size: 0.9rem; }
.ir-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
  align-items: center;
}
.ir-search {
  flex: 1;
  min-width: 200px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  background: #ffffff;
  border: 1px solid #d1d9e6;
  border-radius: 8px;
  height: 40px;
}
.ir-search i { color: #94a3b8; font-size: 0.9rem; }
.ir-search input {
  border: none;
  background: none;
  outline: none;
  flex: 1;
  font-size: 0.85rem;
  color: #1e293b;
  font-family: inherit;
}
.ir-search input::placeholder { color: #94a3b8; }
.ir-sort-select {
  padding: 8px 12px;
  border: 1px solid #d1d9e6;
  border-radius: 8px;
  font-size: 0.82rem;
  color: #475569;
  background: #ffffff;
  font-family: inherit;
  cursor: pointer;
}
.ir-table-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.ir-table-scroll { overflow-x: auto; }
.ir-table { width: 100%; border-collapse: collapse; font-size: 0.82rem; }
.ir-table th {
  text-align: left; padding: 12px 16px;
  font-size: 0.65rem; font-weight: 700; color: #64748b;
  text-transform: uppercase; letter-spacing: 0.07em;
  border-bottom: 2px solid #e2e8f0;
  background: #f8fafc; white-space: nowrap;
}
.ir-table td { padding: 12px 16px; border-bottom: 1px solid #f1f5f9; vertical-align: middle; color: #1e293b; }
.ir-table tbody tr:hover { background: #f0f4f8; }
.ir-table tbody tr:last-child td { border-bottom: none; }
.ir-empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #64748b;
}
.ir-empty-state i { font-size: 3rem; color: #cbd5e1; margin-bottom: 16px; display: block; }
.ir-empty-state p { font-size: 0.9rem; margin: 0; }
.ir-empty-state .sub { font-size: 0.78rem; color: #94a3b8; margin-top: 6px; }
.ir-status { display: inline-flex; align-items: center; gap: 4px; padding: 3px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600; }
.ir-status-sent { background: #d1fae5; color: #065f46; }
.ir-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 14px 16px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}
.ir-page-btn {
  min-width: 34px;
  height: 34px;
  border: 1px solid #d1d9e6;
  background: #ffffff;
  color: #475569;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: inherit;
}
.ir-page-btn:hover:not(:disabled) { background: #f1f5f9; border-color: #94a3b8; }
.ir-page-btn:disabled { opacity: 0.3; cursor: not-allowed; }
.ir-page-btn.active { background: #003366; color: #ffffff; border-color: #003366; }
.ir-info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.78rem;
  color: #64748b;
}
.ir-skeleton {
  padding: 20px 16px;
}
.ir-skeleton-row {
  height: 20px;
  background: linear-gradient(90deg, #e2e8f0 25%, #f1f5f9 50%, #e2e8f0 75%);
  background-size: 200% 100%;
  animation: irShimmer 1.5s ease-in-out infinite;
  border-radius: 4px;
  margin-bottom: 12px;
}
@keyframes irShimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
@media (max-width: 768px) {
  .ir-tabs { gap: 6px; }
  .ir-tab { padding: 8px 14px; font-size: 0.76rem; }
  .ir-table { font-size: 0.75rem; }
  .ir-table th, .ir-table td { padding: 8px 10px; }
}
  `}</style>
);

export default function IbikorwaRemezoMudugudu() {
  const { toast } = useToast();
  const [allRecords, setAllRecords] = useState([]);
  const [isiboNames, setIsiboNames] = useState([]);
  const [activeIsibo, setActiveIsibo] = useState(null);
  const [search, setSearch] = useState("");
  const [sortOrder, setSortOrder] = useState("newest");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const perPage = 10;

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const [recordsRes, namesRes] = await Promise.all([
        axios.get(`${API}/api/ibikorwa-remezo`),
        axios.get(`${API}/api/ibikorwa-remezo/isibo-names`),
      ]);
      setAllRecords(recordsRes.data || []);
      const names = namesRes.data || [];
      setIsiboNames(names);
      if (!activeIsibo && names.length > 0) {
        setActiveIsibo(names[0]);
      } else if (activeIsibo && !names.includes(activeIsibo)) {
        setActiveIsibo(names.length > 0 ? names[0] : null);
      }
    } catch {
      toast({ type: "danger", title: "Ikosa", message: "Habaye ikosa mu gupanga amakuru" });
    } finally {
      setLoading(false);
    }
  }, [activeIsibo]);

  useEffect(() => { fetchData(); }, []);

  // Real-time updates via Socket.IO
  useEffect(() => {
    const token = localStorage.getItem("token");
    const socket = io(SOCKET_URL, {
      auth: { token },
      transports: ["websocket", "polling"],
    });
    socket.on("connect", () => {});
    socket.on("ibikorwa-remezo-updated", (data) => {
      fetchData();
    });
    return () => { socket.disconnect(); };
  }, [fetchData]);

  const filteredRecords = useMemo(() => {
    let items = allRecords;
    if (activeIsibo) {
      items = items.filter((r) => r.izina_isibo === activeIsibo);
    }
    if (search) {
      const q = search.toLowerCase();
      items = items.filter(
        (r) =>
          (r.izina_ry_umuturage || "").toLowerCase().includes(q) ||
          (r.nimero_yirangamuntu || "").toLowerCase().includes(q) ||
          (r.upa_y_icyibanza || "").toLowerCase().includes(q)
      );
    }
    items.sort((a, b) => {
      const da = new Date(a.created_at || 0).getTime();
      const db = new Date(b.created_at || 0).getTime();
      return sortOrder === "newest" ? db - da : da - db;
    });
    return items;
  }, [allRecords, activeIsibo, search, sortOrder]);

  const totalPages = Math.max(1, Math.ceil(filteredRecords.length / perPage));
  const paginatedRecords = filteredRecords.slice((page - 1) * perPage, page * perPage);

  useEffect(() => { setPage(1); }, [activeIsibo, search, sortOrder]);

  const formatDate = (d) => {
    if (!d) return "";
    return new Date(d).toLocaleDateString("rw-RW", { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  };

  return (
    <>
      <Styles />
      <div className="ir-container">
        {/* Header */}
        <div className="ir-header-card">
          <h2><i className="bi bi-building-gear" /> Ibikorwa Remezo</h2>
          <p>Reba ibikorwa remezo byoherejwe n'Isibo ziri munsi y'Umudugudu wawe</p>
        </div>

        {/* Dynamic Tabs */}
        {isiboNames.length > 0 ? (
          <div className="ir-tabs">
            {isiboNames.map((name) => (
              <button
                key={name}
                className={`ir-tab ${activeIsibo === name ? "active" : ""}`}
                onClick={() => setActiveIsibo(name)}
              >
                <i className={`bi ${activeIsibo === name ? "bi-folder-fill" : "bi-folder"}`} />
                {name}
              </button>
            ))}
          </div>
        ) : !loading ? (
          <div className="ir-empty-state">
            <i className="bi bi-inbox" />
            <p>Nta bikorwa remezo byoherejwe n'iyi Sibo</p>
          </div>
        ) : null}

        {/* Search and Sort Controls */}
        <div className="ir-controls">
          <div className="ir-search">
            <i className="bi bi-search" />
            <input
              type="text"
              placeholder="Shakisha ku izina, indangamuntu, UPA..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            {search && (
              <button
                onClick={() => setSearch("")}
                style={{ background: "none", border: "none", color: "#94a3b8", cursor: "pointer", padding: 0 }}
              >
                <i className="bi bi-x-lg" />
              </button>
            )}
          </div>
          <select className="ir-sort-select" value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
            <option value="newest">Bishya ku Ikarabuye</option>
            <option value="oldest">Bikera ku Ikarabuye</option>
          </select>
        </div>

        {/* Records Table */}
        <div className="ir-table-card">
          <div className="ir-info-bar">
            <span><i className="bi bi-funnel" /> {filteredRecords.length} records</span>
            {activeIsibo && <span><i className="bi bi-folder" /> {activeIsibo}</span>}
          </div>
          <div className="ir-table-scroll">
            <table className="ir-table">
              <thead>
                <tr>
                  <th>Izina ry'Umuturage</th>
                  <th>Nimero y'Irangamuntu</th>
                  <th>UPA y'Icyibanza</th>
                  <th>Icyibanza</th>
                  <th>Igikorwa Remezo</th>
                  <th>Itariki</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={7}>
                      <div className="ir-skeleton">
                        {Array.from({ length: 5 }).map((_, i) => (
                          <div key={i} className="ir-skeleton-row" style={{ width: `${80 + Math.random() * 20}%` }} />
                        ))}
                      </div>
                    </td>
                  </tr>
                ) : paginatedRecords.length === 0 ? (
                  <tr>
                    <td colSpan={7}>
                      <div className="ir-empty-state">
                        <i className="bi bi-inbox" />
                        <p>Nta bikorwa remezo byoherejwe n'iyi Sibo</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  paginatedRecords.map((r) => (
                    <tr key={r.id}>
                      <td style={{ fontWeight: 600, color: "#1e293b" }}>{r.izina_ry_umuturage}</td>
                      <td>{r.nimero_yirangamuntu}</td>
                      <td>{r.upa_y_icyibanza}</td>
                      <td>{r.icyibanza}</td>
                      <td>{r.igikorwa_remezo}</td>
                      <td style={{ fontSize: "0.75rem", color: "#64748b" }}>{formatDate(r.created_at)}</td>
                      <td>
                        <span className="ir-status ir-status-sent">
                          <i className="bi bi-check-circle" /> Byoherejwe
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="ir-pagination">
              <button className="ir-page-btn" disabled={page <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>
                <i className="bi bi-chevron-left" />
              </button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((pg) => (
                <button
                  key={pg}
                  className={`ir-page-btn ${page === pg ? "active" : ""}`}
                  onClick={() => setPage(pg)}
                >
                  {pg}
                </button>
              ))}
              <button className="ir-page-btn" disabled={page >= totalPages} onClick={() => setPage((p) => Math.min(totalPages, p + 1))}>
                <i className="bi bi-chevron-right" />
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
